<div>
    <ui-lightning-icon *ngIf="icon" (mouseover)="showText=true" (mouseout)="showText=false" [iconName]="'utility:'+ icon" [size]="'xx-small'"></ui-lightning-icon>
    <div *ngIf="showText" class="slds-popover slds-popover_tooltip slds-nubbin_top-left" role="tooltip" id="help" style="margin-top:1rem;margin-left:-1rem">
      <div class="slds-popover__body"><ng-content></ng-content></div>
    </div>
  </div>